import { render, staticRenderFns } from "./SpendingShow.vue?vue&type=template&id=4c98d36f&"
import script from "./SpendingShow.vue?vue&type=script&lang=js&"
export * from "./SpendingShow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports